export function entryFunc() {
  const fileBlocks = document.querySelectorAll('[data-entry-file]');
  if (!fileBlocks.length) return;

  fileBlocks.forEach((block) => {
    const dropzone = block.querySelector('.p-entry-form__file-drop');
    const input = block.querySelector('input[type="file"]');
    const fileName = block.querySelector('.p-entry-form__file-name');
    const selectButton = block.querySelector('.p-entry-form__file-select');

    if (!dropzone || !input) return;

    const updateFileName = () => {
      const name = input.files && input.files.length ? input.files[0].name : '';
      if (fileName) {
        fileName.textContent = name;
      }
      dropzone.classList.toggle('has-file', Boolean(name));
    };

    const openFileDialog = (event) => {
      event.preventDefault();
      event.stopPropagation();
      input.click();
    };

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        event.preventDefault();
        event.stopPropagation();
      });
    });

    ['dragenter', 'dragover'].forEach((eventName) => {
      dropzone.addEventListener(eventName, () => {
        dropzone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      dropzone.addEventListener(eventName, () => {
        dropzone.classList.remove('is-dragover');
      });
    });

    dropzone.addEventListener('drop', (event) => {
      if (!event.dataTransfer || !event.dataTransfer.files.length) return;
      input.files = event.dataTransfer.files;
      updateFileName();
    });

    dropzone.addEventListener('click', (event) => {
      if (selectButton && (event.target === selectButton || selectButton.contains(event.target))) {
        return;
      }
      input.click();
    });

    dropzone.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        input.click();
      }
    });

    if (selectButton) {
      selectButton.addEventListener('click', openFileDialog);
    }

    input.addEventListener('change', updateFileName);
  });
}
